module.exports = __webpack_public_path__ + "media/banners/paliwo-baner-893206e9.png";